// extracted by mini-css-extract-plugin
module.exports = {"schedulerContainer":"CustomerPage_schedulerContainer__1Fz-t"};